var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("article", { staticClass: "box" }, [
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("debtor-adjustment-invoice", {
              ref: "invoicechild",
              attrs: { "gst-paid": _vm.gstPaid },
              model: {
                value: _vm.innerValue,
                callback: function ($$v) {
                  _vm.innerValue = $$v
                },
                expression: "innerValue",
              },
            }),
            _c("debtor-adjustment-gst-invoice", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isAdjustGstInvoiceActive,
                  expression: "isAdjustGstInvoiceActive",
                },
              ],
              ref: "gstchild",
              attrs: {
                "gst-paid": _vm.gstPaid,
                "read-only-view": _vm.readOnlyView,
              },
              model: {
                value: _vm.innerValue,
                callback: function ($$v) {
                  _vm.innerValue = $$v
                },
                expression: "innerValue",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }